module.exports = __webpack_public_path__ + "static/media/10.question.001749d4.mp4";